import log from '../../log/index';
import api from '../../../http/api';
import config from '../../../core/config/config.js';
import http from '../../../im-http/index.js';
import storage from '../../../core/utils/storage.js';
import store from '../../../store/index.js';
import Date from '../../../core/utils/date.js';
import _ from 'underscore';
import typeUtil from '../typeUtil/index.js';
import {Message, Notification} from 'element-ui';
import Vue from 'vue';


export default {
    //商户代理提现
    DLTX() {
        let params = {
            messageType: 'addMagentWithdrawal'
        }
        api.DLTXDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addMagentWithdrawal',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //获取分公司管理 理财充值未处理数量
    companyDot() {
        let params = {
            messageType: 'addComFinRecCheck'
        }
        api.DLTXDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addComFinRecCheck',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    // 获取分公司提现审核
    comWithdrawal() {
        let params = {
            messageType: 'addcompanydrawalApproval'
        }
        api.DLTXDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addcompanydrawalApproval',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //获取商户提现审批数量
    merchantDot() {
        let params = {
            messageType: 'addMagetWithdrawCheck'
        }
        api.DLTXDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addMagetWithdrawCheck',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //汇款待审批数量
    remitDot() {
        let params = {
            messageType: 'addRemit'
        }
        api.DLTXDot(params).then(res => {
            log.debug(res)
            if (res.code == 'success') {
                let dots = {
                    type: 'addRemit',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //审核分公司/商户数量
    companyMerchant() {
        let params = {
            state: 'dealWith',
            userType: ["merchant", "vvip", "company"]
        }
        // api.companyMerchantDot(params).then(res => {
        //     if (res.code == 'success') {
        //         let dots = {
        //             type: 'addComOrMagetCheck',
        //             num: res.data
        //         }
        //         store.dispatch('setDotActive', dots);
        //     }
        // })
    },
    //商户购入流量审批数量
    merchantLLDot() {
        let params = {
            messageType: 'addMagetLimitBalance'
        }
        api.merchantByDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addMagetLimitBalance',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //会员提额审批数量
    userTS() {
        let params = {
            messageType: 'addLimitBalance'
        }
        api.merchantByDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addLimitBalance',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //商户入金故障单待处理数量
    merchantGold() {
        let params = {
            messageType: 'addFaultdError'
        }
        api.merchantFaultDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addFaultdError',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //主播货币充值红点提现
    anchorDigitCurrency() {
        let params = {
            messageType: 'addAnchorDigitCurrency'
        }
        api.DIGITDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addAnchorDigitCurrency',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })

    },
    //主播货币充值红点提现
    anchorFaultdError() {
        let params = {
            messageType: 'addAnchorFaultdError'
        }
        api.merchantFaultDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addAnchorFaultdError',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },


    //会员提现中心-提现故障单待处理数量
    userTX() {
        let params = {
            messageType: 'addaddFaultdError'
        }
        api.merchantFaultDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addaddFaultdError',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    // 会员提现中心-匹配失败列表
    matchFailed() {
        let dots = {
            type: 'sendASingleFailure',
            num: storage.get('matchFailedsDots')
        }
        store.dispatch('setDotActive', dots);
    },
    //普通理财待审批待处理数量
    PTLC() {
        let params = {
            messageType: 'addWithdraw'
        }
        api.PTLCDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addWithdraw',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //全球理财待审批待处理数量
    QQLC() {
        let params = {
            messageType: 'addGobleWithdraw'
        }
        api.PTLCDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addGobleWithdraw',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //商户理财待审批待处理数量
    SHLC() {
        let params = {
            messageType: 'addMagetWithdraw'
        }
        api.PTLCDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addMagetWithdraw',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //商户入金冻结待审批待处理数量
    SHDJ() {
        let params = {
            messageType: 'addFreeze'
        }
        api.merchantFreeze(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addFreeze',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //兑换待审批待处理数量
    DHSP() {
        let params = {
            messageType: 'addEntrust'
        }
        api.DHSPDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addEntrust',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //汇款故障单待审批待处理数量
    HKSP() {
        let params = {
            messageType: 'addRemittanceError'
        }
        api.HKGZD(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addRemittanceError',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //交流中心红点
    chatDot() {
        // let user = storage.get('userId');

        let temp = storage.get('chatDot');
        log.debug(temp)
        if (temp && temp <= 0) {
            temp = 0
        }
        let dots = {
            type: 'chat',
            num: temp
        }
        store.dispatch('setDotActive', dots);
    },
    //代理提现-总公司提现红点提示
    DLTXHEAD() {
        let params = {
            messageType: 'addCompanyWithdrawal'
        }
        api.DLTXHEADDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addCompanyWithdrawal',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //商户数字货币审批红点
    SHSZHBSP() {
        let params = {
            messageType: 'addDigitCurrency'
        }
        api.DIGITDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addDigitCurrency',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //总公司购入流量审批红点提示
    HEADLL() {
        let params = {
            messageType: 'addCompanyLimitBalance'
        }
        api.HEADLLDot(params).then(res => {
            log.debug(res)
            if (res.code == 'success') {
                let dots = {
                    type: 'addCompanyLimitBalance',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //商户代理购入流量审批红点提示
    MAFlow() {
        let params = {
            messageType: 'addAgentLimitBalance'
        }
        api.HEADLLDot(params).then(res => {
            log.debug(res)
            if (res.code == 'success') {
                let dots = {
                    type: 'addAgentLimitBalance',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //集团分公司流量审核红点提示
    FLOWDot() {
        let params = {
            messageType: 'addControlledCompanyLimitBalance'
        }
        api.FLOWDot(params).then(res => {
            log.debug(res)
            if (res.code == 'success') {
                let dots = {
                    type: 'addControlledCompanyLimitBalance',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    // 直播公司流量购买
    anchorCompanyFlow() {
        let params = {
            messageType: 'addAnchorCompanyLimit'
        }
        api.FLOWDot(params).then(res => {
            log.debug(res)
            if (res.code == 'success') {
                let dots = {
                    type: 'addAnchorCompanyLimit',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //直播直播、互动主播流量购买
    anchorFlow() {
        let params = {
            messageType: 'addAnchorLimit'
        }
        api.FLOWDot(params).then(res => {
            log.debug(res)
            if (res.code == 'success') {
                let dots = {
                    type: 'addAnchorLimit',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    // 直播公司提现
    anchorCompanyTX() {
        let params = {
            messageType: 'addLiveWithdrawalApproval'
        }
        api.DLTXDot(params).then(res => {
            log.debug(res)
            if (res.code == 'success') {
                let dots = {
                    type: 'addLiveWithdrawalApproval',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
    //幸运理财订单通知
    addAdminLuckMeesage() {
        let params = {
            messageType: 'addAdminLuckMeesage'
        }
        api.DLTXDot(params).then(res => {
            if (res.code == 'success') {
                let dots = {
                    type: 'addAdminLuckMeesage',
                    num: res.data
                }
                store.dispatch('setDotActive', dots);
            }
        })
    },
};
